import { VendorDocumentsListAdmin } from '../../../components/Vendor';

export function VendorDocuments() {
  return <VendorDocumentsListAdmin />;
}
